export function ENVDefaultObj() {
  this['env'] = {
    selectId          : '',
    optionHeadVisible : true,
    optionHeadArr     : [],
    optionBodyArr     : [],
    noDataMessage     : 'No data avaliable',
    indexAttribute    : '',
    styleObj          : {},
    printoutFn        : function() {},
    refFn             : function() {},
    featureSearch     : {
      enable                 : false,
      searchSpecAttributeArr : []
    }
  };
}

export function POInfoObj (id) {
  this['printout'] = {
    selectId   : id,
    candidates : [],
    inputValue : []
  };
}
